import React from 'react'

const PrescriptionsDetails = () => {
  return <></>
}

export default PrescriptionsDetails
